export const SUPER_USERS_EMAIL_LIST: string[] = ['rob@resultcode.nl', 'j.andersen864@gmail.com'];
